
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SecurityService } from '../../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal, { SweetAlertResult } from "sweetalert2";
import { Router } from '@angular/router';

@Component({
  selector: 'app-nuevo-componente',
  templateUrl: './nuevo-componente.component.html',
  styleUrls: ['./nuevo-componente.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class NuevoComponenteComponent implements OnInit {
  tipoSeleccionado: number = 0;
  @Output() cerrarPopUpComponente = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();
  disableSelect: boolean = false;
  viewSelect: boolean = true;
  editar: boolean;
  loading: boolean = false;
  isLoading = true;
  save: boolean = false;
  repSistemas: any = [];
  RepComponentes: any = [];
  arrayPadre: any = [];
  dataComponente: any;
  id_sistema: any;
  user: any;
  ipAddress: any;
  formularioComponente: FormGroup;
  idEmpresa: string;
  Titulo: string;

  constructor(private securityService: SecurityService,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    try {
      this.dataComponente = this.securityService.dataComponente;

    } catch (error) {
      this.router.navigate(['/componente/listado']);
    }

    this.Titulo = "Nuevo Componente";
    this.editar = false;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.formularioComponente = new FormGroup({
      id_componente: new FormControl(this.dataComponente.id_componente),
      id_sistemas: new FormControl('', [Validators.required]),
      id_componente_padre: new FormControl('', [Validators.required]),
      Componente: new FormControl('', [Validators.required]),
      Descripcion: new FormControl('', [Validators.required]),
      Tipo_Componente: new FormControl('', [Validators.required]),
      Ruta: new FormControl('', [Validators.required]),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    },
    )

  }

  ngOnInit() {
    this.ObtenerListaSistemas();
    this.ObtenerListaComponentes();

    if (this.securityService.dataComponente != "") {
      this.disableSelect = true;
      this.viewSelect = false;
      this.loading = true;
      this.Titulo = "Editar Componente";
      this.editar = true;
      this.formularioComponente.controls['Componente'].setValue(this.dataComponente.Componente);
      this.formularioComponente.controls['Descripcion'].setValue(this.dataComponente.Descripcion);
      this.formularioComponente.controls['Tipo_Componente'].setValue(this.dataComponente.Tipo_Componente);
      this.formularioComponente.controls['id_sistemas'].setValue(this.dataComponente.id_sistemas);
      this.formularioComponente.controls['id_componente_padre'].setValue(this.dataComponente.id_componente_padre);
      this.formularioComponente.controls['Ruta'].setValue(this.dataComponente.Ruta);

      this.FiltrarComponente(this.dataComponente.id_sistemas);

    }
    this.loading = false;

  }

  GuardarComponente() {

    if (this.formularioComponente.invalid) {

      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verificar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }

    if (this.editar) {

      Swal.fire({
        title: 'Espere',
        text: 'Actualizando Información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();

      this.securityService.ActualizarComponente(this.formularioComponente.getRawValue())
        .subscribe(resp => {

          Swal.fire({
            title: "Éxito",
            text: "Componente actualizado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.redirect(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "COMPONENTE NO ACTUALIZADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    } else {
      Swal.fire({
        title: 'Espere',
        text: 'Guardando información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();

      this.securityService.RegistrarComponente(this.formularioComponente.getRawValue())
        .subscribe(resp => {

          Swal.fire({
            title: "Éxito",
            text: "Componente guardado correctamente.",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.redirect(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "COMPONENTE NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    }
  }

  redirect(res: SweetAlertResult) {
    if (res.value) {
      this.cerrarPopUpComponente.emit();
      this.refresh.emit();
      this.router.navigate(['/componentes/listado']);
    }
  }

  ObtenerListaSistemas() {
    this.loading = true;
    this.securityService.ObtenerListaSistemas()
      .subscribe(resp => {
        this.repSistemas = resp
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error(err);

        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA SISTEMAS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  ObtenerListaComponentes() {
    this.loading = true;
    let tc = "";
    this.securityService.ObtenerListaComponentes(tc)
      .subscribe(resp => {
        this.RepComponentes = resp
        this.FiltrarCoomponentesPadres();
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA COMPONENTES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })


  }

  FiltrarCoomponentesPadres() {
    this.RepComponentes.forEach(item => {
      if (item.id_componente_padre == 0) {
        this.arrayPadre.push(item);
      }
    });
  }

  FiltrarComponente(element: any) {
    this.id_sistema = element;
    this.filterItemsOfId();
  }

  filterItemsOfId() {
    if (this.securityService.dataComponente != "") {
      return this.RepComponentes.filter(x => x.id_sistemas == this.id_sistema);

    } else {
      return this.arrayPadre.filter(x => x.id_sistemas == this.id_sistema);
    }
  }
  CerrarPopUp() {
    this.cerrarPopUpComponente.emit();
  }

}
